var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFiSrCollapseArrowsAlt(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1 1 5 5"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    strokeLinejoin: "round",
    d: "M4 6h2V4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m15 1-5 5"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    strokeLinejoin: "round",
    d: "M12 6h-2V4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1 15 5-5"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    strokeLinejoin: "round",
    d: "M4 10h2v2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m15 15-5-5"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    strokeLinejoin: "round",
    d: "M12 10h-2v2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v16H0z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFiSrCollapseArrowsAlt);
export default __webpack_public_path__ + "static/media/fi-sr-collapse-arrows-alt.bcf1e6ba4c7fd1b91ca03887522af2b6.svg";
export { ForwardRef as ReactComponent };